module.exports = {
      id: "apple-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "svg-sprite.svg#apple",
      toString: function () {
        return this.url;
      }
    }